import { useEffect, useState } from 'react';
import packageJson from '../../../package.json';

import { getAppConfig } from '../../utils/appConfig';
import DataAdminServiceFactory from '../../services/DataAdminServiceFactory';
const dataAdminServiceFactory = new DataAdminServiceFactory();

const config = getAppConfig();

const Health = (): React.JSX.Element => {
  const [serviceHealth, setServiceHealth] = useState<object>([]);

  useEffect(() => {
    const fetchCases = async (): Promise<void> => {
      const service = dataAdminServiceFactory.create(config.ENV || '');
      let servicehealth;
      try {
        servicehealth = await service.getServiceHealth();
        setServiceHealth(servicehealth);
      } catch (error) {
        console.error('Error fetching service health:', error);
        setServiceHealth({ error: 'Failed to fetch service health' });
      }
    };

    fetchCases();
  }, []);

  return (
    <div className="case-list-container">
      <div className="case-graph-container">
        <div style={{ padding: '10px 0px' }}>
          <h1>Health Check</h1>
        </div>
        <div>App is responding.</div>
        <div>Last checked: {new Date().toLocaleString()}</div>
        <div>Version: {packageJson.version}</div>
        <div>API Host: {config.DATA_ADMIN_API_URL}</div>
        <div>User Pool ID: {config.USER_POOL_ID}</div>
        <div>User Pool Client ID: {config.USER_POOL_CLIENT_ID}</div>
        <div>Environment: {config.ENV}</div>
      </div>
      <div className="case-graph-container">
        <div className="section-title">API Service Health</div>
        <div className="health-status">
          {Object.entries(serviceHealth).length > 0 ? (
            Object.entries(serviceHealth).map(([key, value]) => (
              <div key={key} className="health-item">
                <strong>{key}:</strong> {JSON.stringify(value)}
              </div>
            ))
          ) : (
            <div>No health data available.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Health;
